export enum PackagesLabelType {
  Confort = "Confort",
  ConfortPlus = "Confort+",
  Lilloise = "Lilloise",
  Parisienne = "Parisienne",
  Solidaire = "Solidaire",
  Tourquennoise = "Tourquennoise",
  Marseillaise = "Marseillaise",
  Bailleur_Sociaux = "Bailleur Sociaux",
  Etudiante = "Etudiante",
  Cristolienne = "Cristolienne",
  Grenobloise = "Grenobloise",
  Essentielle = "Essentielle",
  // SA
  Tranquilite80 = "Tranquillité 80%",
  Tranquilite65 = "Tranquillité 65%",
  Securite = "S�curit�",
  //PJ
  ProtectionJuridique = "Protection Juridique",
}
